import {
  saveOrUpdateNewsTypeApi,
  queryNewsTypeApi,
  deleteNewsTypeApi,
  getNewsTypeByIdApi,
  saveOrUpdateNewsApi,
  queryNewsApi,
  updateNewsStatusApi,
  getNewsByIdApi
} from '@/api'
const state = {}
const getters = {}
const mutations = {}
const actions = {
  //  新增/更新新闻类别
  async saveOrUpdateNewsTypeAction(context, param) {
    const res = await saveOrUpdateNewsTypeApi(param)
    return res
  },
  //  分页查询新闻类别
  async queryNewsTypeAction(context, param) {
    const res = await queryNewsTypeApi(param)
    return res
  },
  //  删除新闻类别
  async deleteNewsTypeAction(context, param) {
    const res = await deleteNewsTypeApi(param)
    return res
  },
  //  根据id查新闻类别详情
  async getNewsTypeByIdAction(context, param) {
    const res = await getNewsTypeByIdApi(param)
    return res
  },
  //  新增/更新新闻
  async saveOrUpdateNewsAction(context, param) {
    const res = await saveOrUpdateNewsApi(param)
    return res
  },
  //  分页查询新闻
  async queryNewsAction(context, param) {
    const res = await queryNewsApi(param)
    return res
  },
  //  上架/下架/作废新闻
  async updateNewsStatusAction(context, param) {
    const res = await updateNewsStatusApi(param)
    return res
  },
  //  根据id获取新闻详情
  async getNewsByIdAction(context, param) {
    const res = await getNewsByIdApi(param)
    return res
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
